
$(document).ready(function() {

    function hide_free_gift() {
        let free_gift = $('#slidecarthq .upsells-stacked').find('[data-slidecart-product-id="7025168253002"]');
        let upsell_base_variant_1 = $('#slidecarthq .items').find('[data-line-item-id="39752258617418"]');
        let upsell_base_variant_2 = $('#slidecarthq .items').find('[data-line-item-id="39743266455626"]');
        let upsell_base_variant_3 = $('#slidecarthq .items').find('[data-line-item-id="39861747482698"]');
        let upsell_base_variant_4 = $('#slidecarthq .items').find('[data-line-item-id="39862287138890"]');
        
        
        if(!(free_gift.length > 0 && (upsell_base_variant_1.length > 0 || upsell_base_variant_2.length > 0 || upsell_base_variant_3.length > 0 || upsell_base_variant_4.length > 0) )) {
            $('#slidecarthq .upsells-stacked').find('[data-slidecart-product-id="7025168253002"]').hide();            
        } 
        
        if($('#slidecarthq .items').find('[data-line-item-id="39743266488394"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39743266521162"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39752258551882"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39752258584650"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39861747449930"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39861747417162"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39862287171658"]').length > 0 || $('#slidecarthq .items').find('[data-line-item-id="39862287204426"]').length > 0){
            $('#slidecarthq .upsells-header').hide();
        }
    }

    // Run when side cart is opened
    window.SLIDECART_OPENED = function() {
        setTimeout(function(){
            hide_free_gift();
        }, 500);
        
    }

    // Run when side cart is updated
    window.SLIDECART_UPDATED = function() {
        setTimeout(function(){
            hide_free_gift();
        }, 500);
    }
});
